export const PROJECT_OPEN_REQUESTED = 'PROJECT_OPEN_REQUESTED';
export const PROJECT_PUBLISH_REQUESTED = 'PROJECT_PUBLISH_REQUESTED';
export const PROJECT_PUBLISH_CANCELLED = 'PROJECT_PUBLISH_CANCELLED';
export const PROJECT_PUBLISH_START = 'PROJECT_PUBLISH_START';
export const PROJECT_PUBLISH_SUCCESS = 'PROJECT_PUBLISH_SUCCESS';
export const PROJECT_PUBLISH_FAIL = 'PROJECT_PUBLISH_FAIL';
export const PROJECT_SET_API_KEY = 'PROJECT_SET_API_KEY';

export const PROJECT_CREATE = 'PROJECT_CREATE';
export const PROJECT_OPEN = 'PROJECT_OPEN';
export const PROJECT_IMPORT = 'PROJECT_IMPORT';
export const PROJECT_OPEN_WORKSPACE = 'PROJECT_OPEN_WORKSPACE';
export const PROJECT_UPDATE_META = 'PROJECT_UPDATE_META';

export const NODE_ADD = 'NODE_ADD';
export const NODE_PROPERTY_UPDATED = 'NODE_PROPERTY_UPDATED';
export const NODE_CHANGE_ARITY_LEVEL = 'NODE_CHANGE_ARITY_LEVEL';
export const NODE_CHANGE_SPECIALIZATION = 'NODE_CHANGE_SPECIALIZATION';
export const NODE_RESIZE = 'NODE_RESIZE';

export const COMMENT_ADD = 'COMMENT_ADD';
export const COMMENT_RESIZE = 'COMMENT_RESIZE';
export const COMMENT_SET_CONTENT = 'COMMENT_SET_CONTENT';

export const LINK_ADD = 'LINK_ADD';
export const LINKS_SPLIT_TO_BUSES = 'LINKS_SPLIT_TO_BUSES';

export const ADD_LINKED_NODE = 'ADD_LINKED_NODE';

export const BULK_MOVE_NODES_AND_COMMENTS = 'BULK_MOVE_NODES_AND_COMMENTS';
export const BULK_DELETE_ENTITIES = 'BULK_DELETE_ENTITIES';

export const PATCH_ADD = 'PATCH_ADD';
export const PATCH_RENAME = 'PATCH_RENAME';
export const PATCH_DELETE = 'PATCH_DELETE';
export const PATCH_CLONE = 'PATCH_CLONE';
export const PATCH_DESCRIPTION_UPDATE = 'PATCH_DESCRIPTION_UPDATE';
export const PATCH_MANAGED_ATTACHMENT_UPDATE =
  'PATCH_MANAGED_ATTACHMENT_UPDATE';

export const PATCH_HISTORY_UNDO = 'PATCH_HISTORY_UNDO';
export const PATCH_HISTORY_REDO = 'PATCH_HISTORY_REDO';

export const SAVE_ALL = 'SAVE_ALL';



// WEBPACK FOOTER //
// ../../src/project/actionTypes.js